import React, { useEffect, useState } from "react";
import { orderService } from "../../services/orderService";

const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  return `${date.toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })} à ${date.toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit'
  })}`;
};

const DerniereLivraison = ({ idFournisseur }) => {
  const [lastDelivery, setLastDelivery] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!idFournisseur) {
      return;
    }

    const fetchLastDelivery = async () => {
      setLoading(true);
      try {
        const data = await orderService.getLastDelivery(idFournisseur);
        // Vérifier que les données sont valides avant de les stocker
        if (data && data.DateCommande && data.AdresseLivraison) {
          setLastDelivery(data);
        } else {
          setLastDelivery(null);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération de la dernière livraison :", error);
        setLastDelivery(null);
      } finally {
        setLoading(false);
      }
    };

    fetchLastDelivery();
  }, [idFournisseur]);

  return (
    <>
    {lastDelivery && (
      <div className="ifs-4 p-3 mb-4 border rounded bg-light">
        <h6 className="mb-3">Ta dernière demande de livraison</h6>

        {loading && (
          <div className="placeholder-glow">
            <div className="placeholder col-6 mb-2"></div>
            <div className="placeholder col-8 mb-2"></div>
            <div className="placeholder col-4"></div>
          </div>
        )}

        {!loading && (
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
            <p className="mb-2"><strong>Adresse de livraison :</strong> {lastDelivery.AdresseLivraison}</p>
            <p className="mb-2"><strong>Date demande :</strong> {formatDateTime(lastDelivery.DateCommande)}</p>
            <p className="mb-2"><strong>Total HT :</strong> {lastDelivery.livraisonHT || '0,00'} €</p>
          </div>
        )}
      </div>
    )}
   </>
  );

};

export default DerniereLivraison;


